import { render, staticRenderFns } from "./OperaCompanyWindow.vue?vue&type=template&id=58b1656d&"
import script from "./OperaCompanyWindow.vue?vue&type=script&lang=js&"
export * from "./OperaCompanyWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports